<template>
  <v-container class="mt-8">

  	<v-row>
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" class="pb-4">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text class="pb-0">
            <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Diplomas y certificaciones
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" v-if="actualizar_datos">
        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="text-h6">
            Actualización de datos
          </v-card-title>

          <v-card-text>
            <v-text-field
              v-model="alumno.nombre"
              label="Nombre"
              dense
              outlined
            ></v-text-field>
            
            <v-text-field
              v-model="alumno.apellido_paterno"
              label="Apellido paterno"
              dense
              outlined
            ></v-text-field>
            
            <v-text-field
              v-model="alumno.apellido_materno"
              label="Apellido materno"
              dense
              outlined
            ></v-text-field>

            <div>
              
              Recuerda, que el nombre que escribas, será el que aparecerá en tu certificado 
              <br/> 
              Es <strong>NECESARIO</strong> que tu nombre sea escrito con la primer letra en <strong>MAYÚSCULA</strong> y las demás en <strong>MINÚSCULA</strong>, ejemplo: 
              <br/>
              <strong>C</strong>arlos <strong>A</strong>lberto <strong>H</strong>ernández <strong>C</strong>astillo
              
            </div>

            <v-checkbox 
              label="Acepto que son mis datos están correctos" 
              v-model="terminos" 
              value="1"
              hide-details
            ></v-checkbox>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" class="mr-2" text>Cancelar</v-btn>
            <v-btn color="primary" @click="updateDatos()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" v-else>
        <v-card class="elevation-0 transparent">

          <!-- los diplomas y certificados -->
          <v-row justify="space-around">

            <!-- Teens -->
            <v-col cols="9" md="6" lg="4" v-if="escuela == 1">
              <v-card class="cardShow">
                <v-card-title primary-title class="text-body-1 grey--text">
                  <v-spacer></v-spacer>
                  Teens
                  <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-img :src="teens ?  require('@/assets/certificados/teensbloqueado.jpg') :  require('@/assets/certificados/teensdesbloqueado.jpg')"></v-img>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-text v-if="solicitudTeens">
                  <div class="text-title"><strong>FOLIO:</strong>   {{ solicitudTeens.idcertificado_fisico }}</div>
                  <div class="text-title"><strong>NOMBRE:</strong>  {{ solicitudTeens.nombre_completo }}</div>
                  <div v-if="solicitudTeens.estatus == 0 "><strong>ESTATUS:</strong> <v-chip   small color="blue darken-3"   dark> Solicitado </v-chip></div>
                  <div v-if="solicitudTeens.estatus == 1 "><strong>ESTATUS:</strong> <v-chip   small color="cyan darken-3"   dark> Creado     </v-chip></div>
                  <div v-if="solicitudTeens.estatus == 2 "><strong>ESTATUS:</strong> <v-chip   small color="teal accent-3"   dark> Enivado    </v-chip></div>
                  <div v-if="solicitudTeens.estatus == 3 "><strong>ESTATUS:</strong> <v-chip   small color="orange darken-3" dark> Recibido   </v-chip></div>
                  <div v-if="solicitudTeens.estatus == 4 "><strong>ESTATUS:</strong> <v-chip   small color="green"           dark> Entregado  </v-chip></div>
                </v-card-text>

                <v-card-text v-if="!teens">
                  <div class="text-subtitle-1"><strong>Para poder habilitar esta opción, es necesario acreditar tus 16 niveles</strong></div>
                </v-card-text>

                <!-- Descargar copia, siempre habilitado -->
                <v-card-actions v-if="teens">
                  <v-btn color="orange"  block dark class="mr-2 text-caption" @click="generarCopiaCatorceNiveles( false )">Descargar copia</v-btn>
                </v-card-actions>
                <!-- solicitar copia -->
                <v-card-actions v-if="!solicitudTeens && teens && !teens.grupo_online">
                  <v-btn color="primary" block @click="solicitarFisicoCatorceNiveles( 0 )" class="text-caption">Solicitar Fisico</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <!-- Adultos -->
            <v-col cols="9" md="6" lg="4" >
              <v-card class="cardShow">
                <v-card-title primary-title class="text-body-1 grey--text">
                  <v-spacer></v-spacer>
                  Finalización
                  <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-img :src="adultos ? require('@/assets/certificados/nivel14Fast.jpg') : require('@/assets/certificados/NonivelesFAST.jpg')" v-if="escuela == 2"></v-img>
                      <v-img :src="adultos ? require('@/assets/certificados/nivel14Inbi.jpg') : require('@/assets/certificados/NonivelesInbi.jpg')" v-if="escuela == 1"></v-img>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-text v-if="solicitudAdultos">
                  <div class="text-title"><strong>FOLIO:</strong>   {{ solicitudAdultos.idcertificado_fisico }}</div>
                  <div class="text-title"><strong>NOMBRE:</strong>  {{ solicitudAdultos.nombre_completo }}</div>
                  <div v-if="solicitudAdultos.estatus == 0 "><strong>ESTATUS:</strong> <v-chip   small color="blue darken-3"   dark> Solicitado </v-chip></div>
                  <div v-if="solicitudAdultos.estatus == 1 "><strong>ESTATUS:</strong> <v-chip   small color="cyan darken-3"   dark> Creado     </v-chip></div>
                  <div v-if="solicitudAdultos.estatus == 2 "><strong>ESTATUS:</strong> <v-chip   small color="teal accent-3"   dark> Enivado    </v-chip></div>
                  <div v-if="solicitudAdultos.estatus == 3 "><strong>ESTATUS:</strong> <v-chip   small color="orange darken-3" dark> Recibido   </v-chip></div>
                  <div v-if="solicitudAdultos.estatus == 4 "><strong>ESTATUS:</strong> <v-chip   small color="green"           dark> Entregado  </v-chip></div>
                </v-card-text>

                <v-card-text v-if="!adultos">
	                <div class="text-subtitle-1"><strong>Para poder habilitar esta opción, es necesario acreditar tus 14 niveles</strong></div>
	              </v-card-text>

                <v-card-actions v-if="adultos">
                  <v-btn color="orange"  block dark class="mr-2 text-caption" @click="generarCopiaCatorceNiveles( true )">Descargar copia</v-btn>
                </v-card-actions>
                <v-card-actions v-if="!solicitudAdultos && adultos && !adultos.grupo_online">
                  <v-btn color="primary" block @click="solicitarFisicoCatorceNiveles( 1 )" class="text-caption">Solicitar Fisico</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <!-- Cambridge -->
            <v-col cols="9" md="6" lg="4">
              <v-card class="elevation-0 cardShow">
                <v-card-title primary-title class="text-body-1 grey--text">
                  <v-spacer></v-spacer>
                  Cambridge
                  <v-spacer></v-spacer>
                </v-card-title>


                <v-card-text>
                  <v-row justify="center">
                    <v-col cols="12" md="8">
                      <v-img 
                      	:src="certificado ? require('@/assets/certificados/cambridgeFast.jpg') : require('@/assets/certificados/plantilla_fast_B1.jpg')"
                      	v-if="escuela == 2"
                      >
                      </v-img>

                      <v-img 
                        :src="certificado ? require('@/assets/certificados/cambridgeInbi.jpg') : require('@/assets/certificados/plantilla_inbi_B1.jpg')"
                        v-if="escuela == 1"
                      >
                      </v-img>

                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-text v-if="certificado && !['A1','A2','C1',''].includes( certificado.nivel ) && certificado.estatus > 0">
                  <div class="text-title"><strong>FOLIO:</strong>   {{ certificado.idcertificacion }}</div>
                  <div class="text-title"><strong>NOMBRE:</strong>  {{ certificado.nombre_completo }}</div>
                  <div v-if="certificado.estatus == 1 "><strong>ESTATUS:</strong> <v-chip small color="red"                   dark> En proceso      </v-chip></div>
                  <div v-if="certificado.estatus == 2 "><strong>ESTATUS:</strong> <v-chip small color="deep-purple darken-3"  dark> Generado        </v-chip></div>
                  <div v-if="certificado.estatus == 3 "><strong>ESTATUS:</strong> <v-chip small color="blue darken-3"         dark> Solicitado      </v-chip></div>
                  <div v-if="certificado.estatus == 4 "><strong>ESTATUS:</strong> <v-chip small color="cyan darken-3"         dark> Impreso         </v-chip></div>
                  <div v-if="certificado.estatus == 5 "><strong>ESTATUS:</strong> <v-chip small color="teal accent-3"         dark> Eniviado        </v-chip></div>
                  <div v-if="certificado.estatus == 6 "><strong>ESTATUS:</strong> <v-chip small color="orange darken-3"       dark> Recibido        </v-chip></div>
                  <div v-if="certificado.estatus == 7 "><strong>ESTATUS:</strong> <v-chip small color="green"                 dark> Entregado       </v-chip></div>
                </v-card-text>

                <!-- Botonos para pedir o descargar -->
                <!-- Solo si tiene certificación y tiene resultado -->
                <v-card-actions v-if="certificado && !['A1','A2','C1',''].includes( certificado.nivel )">
                  <v-btn color="orange"  block dark class="mr-2 text-caption" @click="generarCopiaCambridge()">Descargar copia</v-btn>
                </v-card-actions>

                <!-- Solicitar fisico cuando tenga resultado valido -->
                <v-card-actions v-if="certificado && !['A1','A2','C1',''].includes( certificado.nivel ) && certificado.estatus == 0">
                  <v-btn color="primary" block @click="solicitarFisicoCambridge()" class="text-caption">Solicitar Fisico</v-btn>
                </v-card-actions>

                <!-- Alerta, con resultado pero no valido -->
                <v-card-actions v-if="certificado && ['A1','A2','C1'].includes( certificado.nivel )">
                  <v-alert
                    border="right"
                    color="blue-grey"
                    dark
                  >
                    Hola, COPIA el siguiente codigo y envíaselo a tu sucursal para poder continuar con tu tramite <strong>CAMBCERTIFICA</strong>
                  </v-alert>
                </v-card-actions>

                <!-- Alerta, codigo asignado, pero no tiene resultado-->
                <v-card-actions v-if="certificado && certificado.nivel == ''">
                  <v-alert
                    border="right"
                    color="green"
                    dark
                  >
                    Hola, tu código ya fue asignado, pero aún no tenemos tu resultado, si ya lo contestaste, por favor, levanta un ticket
                  </v-alert>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-speed-dial
      top
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          dark
          fab
          :to="{name: 'Perfil'}"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

  </v-container>
</template>

<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'
	const  base64 = require('base-64');

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  export default {
  	components:{
  		Alerta,
			Loader
  	},

    data: () => ({
      terminos: null, 
      matricula:'',

      escuela: 0, //FAS
      // escuela:1, //INBI
      actualizar_datos:false,
      alumno:null,

      // Niveles
      diploma_catorce_niveles: false,
      boton14Niveles: true,
      solicitudNiveles: false,
      sin_datos_niveles: false,
      bloqueadoFisicoCatorce:false,

      // Cambridge
      diplomas_certificaciones:false,
      botonCertificacion: true,
      datos_certificado_cambridge: null,
      sin_datos_cambridge: false,
      bloqueadoFisicoCambridge: false,

      noPasa: false,

      respuestaAlerta: false,
      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

      sinResultadoCambridge: false,

      mostrarCertificacion:false,
      teens:false,
      solicitudAdultos:null,
      solicitudTeens:null,
      adultos:null,
      certificado:null,

     	alumno:null
    }),

    computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS' ])
	  },

    async created(){
    	this.initialize( )
    },

    methods:{
      initialize(){
      	this.cargar = true
        // this.overlay = true
        const id_alumno = base64.encode( this.getUsuarioLMS.id )
        return this.$http.post('academico.alumno.buscar/' + id_alumno).then( response =>{
      		this.cargar = false

          // Definir la escuela
          this.escuela = response.body.escuela

          // Validamos si ya actualizo sus datos
          if(response.body.estatus == 0){
            // No los ha actualizado, hay que hacerlo
            this.alumno = response.body.usuario
            this.actualizar_datos = true
          }else{

          	/***************************************************/
          	/*                  14 NIVELES                     */
          	/***************************************************/
            // Sus datos ya estan actualizados
            // Valdiar 14 niveles
            this.teens            = response.body.teens
            this.adultos          = response.body.adultos
            this.solicitudAdultos = response.body.solicitudAdultos
            this.solicitudTeens   = response.body.solicitudTeens

          	/***************************************************/
          	/*                 CERTIFICACION                   */
          	/***************************************************/

            this.mostrarCertificacion = response.body.mostrarCertificacion
            this.certificado          = response.body.certificado
          }
          this.overlay = false
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

      errorNombreUsuario (  ) {
        this.cargar = false 
        this.parametros.mensaje      = 'Lo sentimos, pero tu nombre no cuenta con los criterios adecuados, por favor revisa los criterios para poder continuar'
        this.parametros.dialogError  = true 
        this.parametros.color        = '#FF2C2C'
        this.respuestaAlerta         = true 
      },

      updateDatos( ){
      	// Validar que el "terminos" haya sido aceptado
        if(!this.terminos){
          this.parametros.mensaje      = 'Para continuar, es necesario aceptar que tus datos están correctos'
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
          return
        }

        // Validar que el nombre este bien escrito
        let letraAnterior = 'a'
        var letras_mayusculas = ['A','B','C','D','E','F','G','H','Y','J','K','L','M','N','Ñ','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
        // Validamos el nombre
        for(const i in this.alumno.nombre){
          if(letras_mayusculas.includes(this.alumno.nombre[i]) && letras_mayusculas.includes(letraAnterior)){
            this.errorNombreUsuario()
            return
          }
          letraAnterior = this.alumno.nombre[i]
        }

        // Validar que el paellido paterno este bien escrito
        letraAnterior = 'a'
        // Validamos el apellido paterno
        for(const i in this.alumno.apellido_paterno){
          if(letras_mayusculas.includes(this.alumno.apellido_paterno[i]) && letras_mayusculas.includes(letraAnterior)){
            this.errorNombreUsuario()
            return
          }
          letraAnterior = this.alumno.apellido_paterno[i]
        }

        // Validar que el apellido materno este bien escrito
        letraAnterior = 'a'
        // Validamos el apellido materno
        for(const i in this.alumno.apellido_materno){
          if(letras_mayusculas.includes(this.alumno.apellido_materno[i]) && letras_mayusculas.includes(letraAnterior)){
            this.errorNombreUsuario()
            return
          }
          letraAnterior = this.alumno.apellido_materno[i]
        }

        // Continuamos, ya paso los filtros

        this.alumno.datos_actualizados = 1

        this.cargar = true
        
        this.$http.post('academico.alumno.update', this.alumno).then( response =>{
        	this.cargar                  = false 
          this.actualizar_datos        = false
          this.initialize( )
        }).catch( error =>{
        	this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      async generarCopiaCatorceNiveles( adultos ) {
        this.cargar = true
        this.getUsuarioLMS['adultos'] = adultos
        this.$http.post('academico.copia.niveles/' + this.escuela, this.getUsuarioLMS).then( response =>{
          window.open( this.$http.options.root + 'copias-certificados/' + response.body.nombreArchivo);
          this.cargar = false
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      async solicitarFisicoCatorceNiveles( adultos ) {
        this.cargar = true

        let payload = {
          iderp:            this.getUsuarioLMS.iderp,
          nombre_completo:  this.getUsuarioLMS.nombre + ' ' + this.getUsuarioLMS.apellido_paterno + ' ' + this.getUsuarioLMS.apellido_materno,
          usuario_registro: this.getUsuarioLMS.iderp,
          estatus:          0, 
          url:              '',
          deleted:          0,
          unidad_negocio:   this.escuela,
          adultos
        }

        this.$http.post('academico.solicitar.certificado', payload).then( response =>{
          this.actualizar_datos         = false
          this.diplomas_certificaciones = false
          this.diploma_catorce_niveles  = false
          this.initialize( )
          this.cargar = false 
	        this.parametros.mensaje      = response.body.message
	        this.parametros.dialogError  = true 
	        this.parametros.color        = 'success'
	        this.respuestaAlerta         = true 
          this.cargar = false
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      async solicitarFisicoCambridge() {
        this.cargar = true

        let payload = {
          idcertificacion:   this.certificado.idcertificacion,
          idusuario:         this.getUsuarioLMS.id,
          nombre_completo:   this.getUsuarioLMS.nombre + ' ' + this.getUsuarioLMS.apellido_paterno + ' ' + this.getUsuarioLMS.apellido_materno,
          estatus:           1
        } 
       
        this.$http.put('academico.certificacion.update', payload).then( response =>{
          this.dialogSuccess            = true
          this.actualizar_datos         = false
          this.diplomas_certificaciones = true
          this.diploma_catorce_niveles  = false
          this.initialize( )
          this.cargar = false
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      async generarCopiaCambridge() {
        this.cargar = true
        this.$http.post('academico.copia.cambridge/' + this.escuela, this.certificado).then( response =>{
          console.log(response.body.nombreArchivo)
          window.open(this.$http.options.root + 'copias-certificados/' + response.body.nombreArchivo);
          this.cargar = false
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      limpiar () {
        this.alumno                   = null
        this.diploma_catorce_niveles  = false
        this.diplomas_certificaciones = false
        this.actualizar_datos         = false
        this.boton14Niveles           = true
        this.solicitudNiveles         = false
        this.certificado              = null
        this.botonCertificacion       = true
        this.sin_datos_niveles        = false
        this.sin_datos_cambridge      = false
      }

    },
  }
</script>
<style scoped>
  .cardShow{
    border-radius: 15px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }

  .colorCurso{
		color: #006093;
	}
</style>
